import React from 'react';
import ExcelDashboard from './ExcelDashboard';
import './App.css';

function App() {
  return (
    <div className="App">
      <ExcelDashboard />
    </div>
  );
}

export default App;